import { render, staticRenderFns } from "./LongzhouPage.vue?vue&type=template&id=69c7e878&scoped=true"
import script from "./LongzhouPage.vue?vue&type=script&lang=js"
export * from "./LongzhouPage.vue?vue&type=script&lang=js"
import style0 from "./LongzhouPage.vue?vue&type=style&index=0&id=69c7e878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c7e878",
  null
  
)

export default component.exports